import * as React from 'react';
export const scotiabankSvg = React.forwardRef(function scotiabankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#D81E05',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M21.64 16.43c.06 2.96-2.78 5.2-5.16 5.2H10.6l-3.68 3.45h9.5c3.03 0 5.94-2.56 5.94-5.63 0-.9-.12-2.07-.72-2.96v-.06zm-.67 1.74c.37-.64.56-1.34.6-2.03h-2.73c0 .64-.11 1.32-.36 2.03h2.49zm-2.67.4a6.11 6.11 0 0 1-1.76 2.26c1.39 0 2.97-.58 4.13-2.26H18.3zm-.3-.4c.23-.64.35-1.34.41-2.03h-4.13c.07.69.18 1.39.42 2.03H18zm-3.77 0c-.24-.7-.38-1.4-.38-2.03h-2.73c.07.69.25 1.39.6 2.03h2.5zm2.12 2.25a6.46 6.46 0 0 0 1.46-1.85h-2.92a6.3 6.3 0 0 0 1.46 1.85zm-4.38-1.85a5.07 5.07 0 0 0 4.2 2.26 5.4 5.4 0 0 1-1.76-2.26h-2.44zm6.5-4.86c.26.62.37 1.32.37 2.02h2.73c-.04-.7-.23-1.4-.6-2.02h-2.5zm2.2-.47A5.08 5.08 0 0 0 16.54 11c.72.51 1.45 1.49 1.76 2.25h2.37zm-5.97.47a7.52 7.52 0 0 0-.42 2.02h4.13c-.06-.7-.18-1.4-.42-2.02H14.7zm-2.97 0a4.9 4.9 0 0 0-.6 2.02h2.72c0-.7.14-1.4.38-2.02h-2.5zm4.62-2.27a6.1 6.1 0 0 0-1.46 1.8h2.92a6.26 6.26 0 0 0-1.46-1.8zm-1.94 1.8A5.2 5.2 0 0 1 16.18 11c-1.41 0-3 .63-4.2 2.25h2.43zm-4.05 2.33a5.49 5.49 0 0 1-.72-2.97c0-3.08 2.91-5.68 5.94-5.68h9.5l-3.69 3.51h-5.87c-2.36 0-5.22 2.27-5.16 5.14z',
      }),
    ),
  );
});
scotiabankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var scotiabank = {
  category: 'brand',
  colorable: false,
  name: 'scotiabank',
  svg: scotiabankSvg,
};
